export enum HeaderType {
	LoanApplication = 'LoanApplication',
	LoanOffer = 'LoanOffer',
	LoanOfferTopUp = 'LoanOfferTopUp',
	None = 'None',
}